import { type SetupImportProblem, describeSetupImportProblem } from './setup-import-messages';

export interface SetupImportRefusalProps {
  problem: SetupImportProblem;
}

/**
 * The red box that replaces the preview when an import cannot apply (board
 * 04): what is wrong, the detail, then what to fix. Nothing is applied, not
 * even partly (rule 10).
 */
export function SetupImportRefusal({ problem }: SetupImportRefusalProps) {
  const { title, details, fix } = describeSetupImportProblem(problem);
  return (
    <div
      role="alert"
      data-testid="setup-import-refusal"
      className="rounded-md border-2 border-rouge bg-rouge-tint p-4 text-small"
    >
      <h3 className="mb-1 font-bold text-body text-rouge-deep">{title}</h3>
      {details.map((detail) => (
        <p key={detail} className="my-1">
          {detail}
        </p>
      ))}
      <p className="mt-2 text-gray-800">{fix}</p>
    </div>
  );
}
